/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'confluence.error.panel.refresh.app': 'Atualizar app',
  'confluence.error.panel.reload.page': 'Recarregar página',
  'confluence.icon.label': 'Ícone',
  'confluence.modal.dialog.close.modal.button': 'Cancelar',
  'confluence.select.required.field.message': 'Este campo é obrigatório.',
  'confluence.text.area.required.field.message': 'Este campo é obrigatório.',
  'confluence.textfield.validator.email': 'Insira um e-mail válido.',
  'confluence.textfield.validator.number': 'Insira um número válido',
  'confluence.textfield.validator.required.field.message': 'Este campo é obrigatório.',
  'confluence.textfield.validator.telephone': 'Insira um telefone válido.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Acesso obrigatório',
  'confluence.threeLOPrompt.modal.error.title': 'Erro',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'URL de consentimento não encontrada. Atualize a página e tente de novo.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'URL de consentimento não encontrada. Atualize a página e tente de novo.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Permitir acesso',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Configurar acesso',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Falha na autenticação.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Para exibir {appString}, você precisa permitir que o app acesse os produtos da Atlassian em seu nome.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} requer acesso adicional à conta.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Aviso de autenticação externa',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'este app',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Este app',
  'confluence.user.group.unknown.user.message': 'Usuário desconhecido',
  'confluence.user.picker.empty.field.error.message': 'Este campo é obrigatório.',
  'confluence.user.unknown.user.message': 'Usuário desconhecido',
  'forge-ui.form.submit-button.text': 'Enviar',
  'forge.modal.deprecation.message':
    'Seu aplicativo {appName} usa a experiência obsoleta de edição modal para campos personalizados, que está sendo eliminada. Peça ao administrador do sistema que atualize o aplicativo para usar a edição em linha. Se os problemas persistirem, entre em contato com o desenvolvedor do aplicativo.',
  'forge.modal.deprecation.title': 'Atualize seu aplicativo',
};
